import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

// Appt Components
import Box from '../components/simple/box/Box'

import ResponsiveGrid from '../components/compound/responsiveGrid/ResponsiveGrid'
import Text from '../components/simple/text/Text'
import SimpleCounterSmall from '../components/compound/simpleCounterSmall/SimpleCounterSmall'

// Shared Components


import LocalStorageService from '../services/LocalStorageService'
import ReportService from '../services/ReportService'

import { openAnalyticsWithFilters } from '../utils/analytics.js'
import moment from 'moment'
import Select from '../components/simple/input/Select.js'
import styled from 'styled-components'
import PulseLoader from 'react-spinners/PulseLoader.js'


const StyledSelect = styled(Select)`
    background: transparent;
    border: none;
    border-radius: 4px;
    color: #fff;
    padding: 8px 12px;

    width: 150px;


    font-weight: bold;
    font-size: 22px;

    svg {
      fill: #fff !important;
      stroke: #fff !important;
      margin-left: 8px;
    }


    &:hover {
      background: darken(#007bff, 5%);
    }


    &:focus {
      border-color: #fff;
      outline: none;
    }
  `;


const DashboardStats = (props) => {
  const navigate = useNavigate()

  const [reportData, setReportData] = useState({})
  const [incidentDamageCountData, setIncidentDamageCountData] = useState([])
  const [numIncidentsInvolvingInjuryToChild,setNumIncidentsInvolvingInjuryToChild] = useState(0);
  const [numIncidentsInvolvingInjuryToStaff,setNumIncidentsInvolvingInjuryToStaff] = useState(0);
  const [numIncidentsInvolvingInjuryToOthers,setNumIncidentsInvolvingInjuryToOthers] = useState(0);


  const [isLoading, setIsLoading] = useState(false)



  const terms = LocalStorageService.get('terms')
  const apiToken = LocalStorageService.get('apiToken')
  const activeOrg = LocalStorageService.get('activeOrg');
  const userDetails = LocalStorageService.get('userDetails');


  const quickStatOptions = [
    { name: 'Last 7 Days', query: [
      { key: "dateOfIncident", operator: "after", response: moment().subtract(7, 'day').format('YYYY-MM-DD'), relation: null},
      { key: "dateOfIncident", operator: "before", response: moment().add(1, 'day').format('YYYY-MM-DD'), relation: null}
    ] },
    { name: 'Last 30 Days', query: [
      { key: "dateOfIncident", operator: "after", response: moment().subtract(30, 'day').format('YYYY-MM-DD'), relation: null},
      { key: "dateOfIncident", operator: "before", response: moment().add(1, 'day').format('YYYY-MM-DD'), relation: null}
    ] },
    { name: 'This Month', query: [
      { key: "dateOfIncident", operator: "after", response: moment().startOf('month').format('YYYY-MM-DD'), relation: null},
      { key: "dateOfIncident", operator: "before", response: moment().add(1, 'day').format('YYYY-MM-DD'), relation: null}
    ] },
    { name: 'Last Month', query: [
      { key: "dateOfIncident", operator: "after", response: moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD'), relation: null},
      { key: "dateOfIncident", operator: "before", response: moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD'), relation: null}
    ] },
    { name: 'This Year', query: [
      { key: "dateOfIncident", operator: "after", response: moment().startOf('year').format('YYYY-MM-DD'),  relation: null},
      { key: "dateOfIncident", operator: "before", response: moment().add(1, 'day').format('YYYY-MM-DD'), relation: null}
    ] },
    { name: 'Last Year', query: [
      { key: "dateOfIncident", operator: "after", response: moment().subtract(1, 'year').startOf('year').format('YYYY-MM-DD'), relation: null},
      { key: "dateOfIncident", operator: "before", response: moment().subtract(1, 'year').endOf('year').format('YYYY-MM-DD'), relation: null}
    ] },
  ]


  const [selectedQuickStat, setSelectedQuickStat] = useState(quickStatOptions[0]?.name)


  const [startDate, setStartDate] = useState(moment().subtract(7, 'day').format('YYYY-MM-DD'))
  const [endDate, setEndDate] = useState(moment().add(1, 'day').format('YYYY-MM-DD'))


  useEffect(() => {

    const selectedOption = quickStatOptions.find(option => option.name === selectedQuickStat)

    if (selectedOption) {
      const query = selectedOption.query

      const startDateFilter = query.find(q => q.key === 'dateOfIncident' && q.operator === 'after')
      const endDateFilter = query.find(q => q.key === 'dateOfIncident' && q.operator === 'before')

      if (startDateFilter) {
        setStartDate(startDateFilter.response)
      }

      if (endDateFilter) {
        setEndDate(endDateFilter.response)
      }

    }

  }, [selectedQuickStat])



  const loadReport = async () => {

    setIsLoading(true)


    let responses = await ReportService.getReport(
        apiToken,
        {
            orgId: activeOrg.id,
            // limit: 100,
            // page: 1
        },
        {
            submissionType: 'incidentReport',
            query: [
                { key: "dateOfIncident", operator: "after", response: startDate, relation: null },
                { key: "dateOfIncident", operator: "before", response: endDate, relation: null }
            ],
            reports: [
                // "totalNumberOfIncidentsByStudent",
                // "totalNumberOfIncidentsByYearGroup",
                // "totalNumberOfIncidentsByStudentGroup",
                // "totalNumberOfIncidentsByDate",
                // "totalNumberOfIncidentsByHour",
                // "totalNumberOfIncidentsByLocation",
                // "totalNumberOfIncidentsBySystemUser",
                "totalNumberOfIncidents",
                "numberIncidentsPhysicalInterventionUsed",
                "numberIncidentsNoPhysicalInterventionUsed",
                "numberIncidentsRestrictedInterventionUsed",
                // "commonIntervention",
                // "commonTechnique",
                // "commonDeescalationTechnique",
                // "commonPhysicalTechnique",
                // "incidentDamageCount",
                // "numberIncidentsRestrictedInterventionUsed",
                // "averageDurationPhysicalIntervention",
                // "totalDurationPhysicalIntervention",
                // "breathingMonitoredByStudentGraph",
                // "breathingMonitoredByYearGroupGraph",
                // "breathingMonitoredByStudentGroupGraph",
                'numIncidentsInvolvingInjuryToChild',
                'numIncidentsInvolvingInjuryToStaff',
                'numIncidentsInvolvingInjuryToOthers',
                'numIncidentsInvolvingInjuryByStudentGroup',
                'numIncidentsInvolvingInjuryWithOtherChildren'
            ],
        },
    ).catch((err) => {
      console.error('Error loading report data', err)
      setIsLoading(false)
    })

    setIsLoading(false)
    setReportData(responses)

  }

  useEffect(() => {
    loadReport()
  }, [startDate, endDate])

  useEffect(() => {
    // Map the API data in reportData into the relevant datasets
       // Child injuries
    if (reportData?.numIncidentsInvolvingInjuryToChild !== null) {
      const numIncidentsInvolvingInjuryToChild =
        reportData?.numIncidentsInvolvingInjuryToChild;

      setNumIncidentsInvolvingInjuryToChild(numIncidentsInvolvingInjuryToChild);
    }

    // Staff injuries
    if (reportData?.numIncidentsInvolvingInjuryToStaff !== null) {
      const numIncidentsInvolvingInjuryToStaff =
        reportData?.numIncidentsInvolvingInjuryToStaff;

      setNumIncidentsInvolvingInjuryToStaff(numIncidentsInvolvingInjuryToStaff);
    }

    // Other injuries
    if (reportData?.numIncidentsInvolvingInjuryToOthers !== null) {
      const numIncidentsInvolvingInjuryToOthers =
        reportData?.numIncidentsInvolvingInjuryToOthers;

      setNumIncidentsInvolvingInjuryToOthers(
        numIncidentsInvolvingInjuryToOthers,
      );
    }



  }, [reportData])




  return (
    <Box direction='column' gap='small' round='small' margin={{ bottom: 'medium' }}>

    <Box direction='row' justify='end' gap='none' pad={{ vertical: 'none', bottom: 'none' }} margin='none'>
            <Box direction='row' align='center' gap='small' margin={{ right: 'small' }} >
               <PulseLoader
                  size={15}
                  color='#ff8300'
                  loading={isLoading}
                />
              <StyledSelect
                color='white'

                labelKey='name'
                plain
                // name='quickSearch'
                onChange={({ value: nextValue }) => {
                  setSelectedQuickStat(nextValue)
                }}
                defaultValue={quickStatOptions[0]}
                options={quickStatOptions}
                value={selectedQuickStat}
                valueKey={{ key: 'name', reduce: true }}
              />
            </Box>
        </Box>
        <ResponsiveGrid
          rows={['auto']}
          columns={{
            small: ['auto'],
            medium: ['auto', 'auto'],
            large: ['auto', 'auto'],
            xlarge: ['auto', 'auto', 'auto', 'auto']
          }}
          gap='small'
          pad='xxsmall'
        >

          <SimpleCounterSmall
            count={reportData?.totalNumberOfIncidents ? String(reportData?.totalNumberOfIncidents) : '0'}
            label='Total Number of Incidents'
            onClick={() =>
              openAnalyticsWithFilters([
              { key: "dateOfIncident", operator: "after", response: startDate, relation: null },
              { key: "dateOfIncident", operator: "before", response: endDate, relation: null }
            ])
            }
          />
          <SimpleCounterSmall
            count={reportData?.numberIncidentsNoPhysicalInterventionUsed ? String(reportData?.numberIncidentsNoPhysicalInterventionUsed) : '0'}
            label='# Incidents that did not include Physical Intervention'
            onClick={() =>
              openAnalyticsWithFilters([{
                "key": "physicalInterventionUsed",
                "operator": "is not",
                "response": "Yes",
                "relation": null
              },
              { key: "dateOfIncident", operator: "after", response: startDate, relation: null},
              { key: "dateOfIncident", operator: "before", response: endDate, relation: null}
            ])
            }
          />
          <SimpleCounterSmall
            count={reportData?.numberIncidentsNoPhysicalInterventionUsed ? String(reportData?.numberIncidentsPhysicalInterventionUsed) : '0'}
            label='# Incidents involving Physical Intervention'
            onClick={() =>
              openAnalyticsWithFilters([{
                "key": "physicalInterventionUsed",
                "operator": "is",
                "response": "Yes",
                "relation": null
              },
              { key: "dateOfIncident", operator: "after", response: startDate, relation: null},
              { key: "dateOfIncident", operator: "before", response: endDate, relation: null}
            ])
            }
          />
          <SimpleCounterSmall
            count={reportData?.numberIncidentsRestrictedInterventionUsed ? String(reportData?.numberIncidentsRestrictedInterventionUsed) : '0'}
            label={<Text># Incidents involving <Text weight="bold">Restrictive</Text> Physical Intervention</Text>}
            onClick={() =>
              openAnalyticsWithFilters([{
                "key": "restrictedPhysicalInterventionUsed",
                "operator": "is",
                "response": "Yes",
                "relation": null
              },
              { key: "dateOfIncident", operator: "after", response: startDate, relation: null},
              { key: "dateOfIncident", operator: "before", response: endDate, relation: null}
            ])
            }
          />
        </ResponsiveGrid>


        {<ResponsiveGrid
          rows={['auto']}
          columns={{
            small: ['auto'],
            medium: ['auto', 'auto'],
            large: ['auto', 'auto', 'auto', 'auto'],
            xlarge: ['auto', 'auto', 'auto', 'auto'],
          }}
          gap="small"
        >
          <SimpleCounterSmall
            count={String(numIncidentsInvolvingInjuryToChild || 0)}
            label={
              terms?.serviceUser
                ? `Incidents involving injury to ${
                    terms?.serviceUser?.charAt(0)?.toUpperCase() +
                    terms?.serviceUser?.slice(1)
                  }`
                : 'Incidents involving injury to Student'
            }
            onClick={() =>
              openAnalyticsWithFilters([
                {
                  key: 'injuryToStudent',
                  operator: 'is',
                  response: 'Yes',
                  relation: null,
                },
                { key: "dateOfIncident", operator: "after", response: startDate, relation: null},
                { key: "dateOfIncident", operator: "before", response: endDate, relation: null}
              ])
            }
          />
          <SimpleCounterSmall
            count={String(numIncidentsInvolvingInjuryToStaff || 0)}
            label="Incidents involving injury to staff member"
            onClick={() =>
              openAnalyticsWithFilters([
                {
                  key: 'injuryToStaff',
                  operator: 'is',
                  response: 'Yes',
                  relation: null,
                },
                { key: "dateOfIncident", operator: "after", response: startDate, relation: null},
                { key: "dateOfIncident", operator: "before", response: endDate, relation: null}
              ])
            }
          />
          <SimpleCounterSmall
            count={String(numIncidentsInvolvingInjuryToOthers || 0)}
            label="Incidents involving injury to other"
            onClick={() =>
              openAnalyticsWithFilters([
                {
                  key: 'injuryToOther',
                  operator: 'is',
                  response: 'Yes',
                  relation: null,
                },
                { key: "dateOfIncident", operator: "after", response: startDate, relation: null},
                { key: "dateOfIncident", operator: "before", response: endDate, relation: null}
              ])
            }
          />
        </ResponsiveGrid>}
      </Box>
  )
}

export default DashboardStats
